export default [
  {
    id: 120,
    title: 'Lists',
    'fa-icon': 'fa-folder',
    children: [
      {
        id: 121,
        title: 'Normal View',
        url: '/#/role',
        perm_id: 'lists.normal',
        'fa-icon': 'fa-file'
      },
      {
        id: 122,
        title: 'Nested View',
        url: '/#/user',
        perm_id: 'lists.nested',
        'fa-icon': 'fa-file'
      },
      {
        id: 123,
        title: 'Parallel View',
        url: '/#/item',
        perm_id: 'lists.parallel',
        'fa-icon': 'fa-file'
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./examples/mock/menu.js